import TicketLogsAPI from '../../api/ticketLogs';

export const getters = {
  getUIFlags: $state => $state.uiFlags,
  getLogs: $state => $state.records,
  getMeta: $state => $state.meta,
};

export const actions = {
  async get({ commit }, { ticketId, page = 1, perPage = 20, eventType = null }) {
    commit('setUIFlags', { isFetching: true });
    try {
      const response = await TicketLogsAPI.getLogs({
        ticketId,
        page,
        perPage,
        eventType,
      });
      
      const { ticket_logs, meta } = response.data;
      
      if (page === 1) {
        commit('setLogs', ticket_logs);
      } else {
        commit('appendLogs', ticket_logs);
      }
      
      commit('setMeta', meta);
      commit('setUIFlags', { isFetching: false });
      return response;
    } catch (error) {
      console.error('Store get action error:', error);
      commit('setUIFlags', { isFetching: false });
      throw error;
    }
  },

  async show({ commit }, { ticketId, logId }) {
    commit('setUIFlags', { isFetchingItem: true });
    try {
      const response = await TicketLogsAPI.getLog({ ticketId, logId });
      commit('addLog', response.data);
      commit('setUIFlags', { isFetchingItem: false });
      return response;
    } catch (error) {
      commit('setUIFlags', { isFetchingItem: false });
      throw error;
    }
  },

  clearLogs({ commit }) {
    commit('clearLogs');
  },
};

export const mutations = {
  setUIFlags($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  setLogs($state, logs) {
    $state.records = logs;
  },
  appendLogs($state, logs) {
    $state.records = [...$state.records, ...logs];
  },
  addLog($state, log) {
    $state.records = [log, ...$state.records];
  },
  setMeta($state, meta) {
    $state.meta = meta;
  },
  clearLogs($state) {
    $state.records = [];
    $state.meta = { total: 0 };
    $state.uiFlags = {
      isFetching: false,
      isFetchingItem: false,
      isFetchingMore: false,
    };
  },
};

export const state = () => ({
  records: [],
  meta: {
    total: 0,
  },
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isFetchingMore: false,
  },
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
